import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import type { TournamentRole, TournamentStatus } from '@/constants';
import { parseTournamentListParams, tournamentSourceFromPath } from '@/utils/tournamentListParams';
import type { TournamentListSource } from '@/types';

/** Which list a header search looks in, with that list's URL filters. */
export interface TournamentSearchScope {
  source: TournamentListSource;
  status?: TournamentStatus;
  season?: string;
  role?: TournamentRole;
}

/**
 * Search scope of the current tab: the list from the pathname (my / public /
 * archived) with the filters it applies — status for my / public, season +
 * role for the archive.
 */
export function useTournamentSearchScope(): TournamentSearchScope {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const source = tournamentSourceFromPath(pathname);
  const { status, season, role } = parseTournamentListParams(searchParams);
  const isArchive = source === 'archived';

  return useMemo(() => (isArchive
    ? { source, season: season ?? undefined, role: role ?? undefined }
    : { source, status: status ?? undefined }
  ), [source, isArchive, status, season, role]);
}
